import Data from './Data';
import View from './View';

export default Data(View);
